/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChurn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2c2.773 0 5.126 1.17 6.825 2.548.43.35.824.715 1.175 1.084V4h2v6h-5V8h2.373a9.982 9.982 0 0 0-1.807-1.898C16.12 4.929 14.196 4 12 4a8 8 0 0 0-4.847 14.366 3.523 3.523 0 0 1 1.13-1.752C9.167 15.868 10.43 15.5 12 15.5s2.833.368 3.717 1.114c.58.49.943 1.097 1.13 1.752A7.987 7.987 0 0 0 20 12h2a10 10 0 1 1-20 0zm12.999 7.42c-.017-.549-.21-.972-.573-1.278-.402-.339-1.14-.642-2.426-.642s-2.024.303-2.426.642c-.363.306-.556.73-.573 1.277.925.375 1.937.581 2.999.581s2.074-.206 2.999-.58zM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgChurn as Churn };
